import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from 'vue-gtm'
import Home from '../views/Home.vue'
import Thanks from '../views/Thanks.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/thanks-retail',
    name: 'ThanksRetail',
    component: Thanks
  },
  {
    path: '/thanks-reseller',
    name: 'ThanksReseller',
    component: Thanks
  },
  {
    path: '/thanks',
    name: 'Thanks',
    component: Thanks
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.use(VueGtm, {
  id: 'GTM-KL98FJH',
  vueRouter: router,
})

export default router
